import { trackRequestResult } from '@ngneat/elf-requests';

/**
 * This returns a trackRequestResult function from Elf that skips caching results and prevents parallel requests from happening.
 *
 * It also allows for strongly typed string literals so each repository can have its own single source of truth for request results keys
 *
 * @example
 * type RequestKeys = 'some-key' | 'some-other-key';
 *
 * export const trackRepoRequests = <T>(keys: RequestKeys[]) =>
 *  trackRequest<T, RequestKeys>(keys);
 *
 * Api.getSomething().pipe(
 *  trackRepoRequests(['some-key])
 * )
 *
 * @param keys Array of string literals to pass through to trackRequestResult function
 * @returns Elf trackRequestResult function with preconfigured options
 */
export const trackRequest = <T, K extends string>(keys: K[]) =>
  trackRequestResult<T>(keys, {
    skipCache: true,
    preventConcurrentRequest: true,
  });
